module.exports = __webpack_public_path__ + "static/media/hands.3b87f4ff.svg";